export enum ColumnDataType {
    String = 'STRING',
    Number = 'NUMBER',
    Date = 'DATE',
    Boolean = 'BOOLEAN',
  }

export const DEVICE_EXPORT_TEMPLATE: SpreadsheetTemplate = {
    name: 'devices',
    columns: [
      { header: 'SIM Serial Number', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Phone Number', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'SIM Provider', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Device Serial Number', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Device IMEI Number', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Device Type', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Issue Date', type: ColumnDataType.Date, forceTextFormat: true },
      { header: 'Configuration', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Configuration Health', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Firmware', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Firmware Health', type: ColumnDataType.String, forceTextFormat: true }
    ]
};

export const PLATFORM_DEVICE_EXPORT_TEMPLATE: SpreadsheetTemplate = {
    name: 'platform-devices',
    columns: [
      { header: 'Serial Number', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'IMEI', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Type', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Partner', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Phone', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'SIM #', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Provider', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Firmware', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Configuration', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Added', type: ColumnDataType.Date },
      { header: 'Configuration Status', type: ColumnDataType.String, forceTextFormat: true },
      { header: 'Firmware Status', type: ColumnDataType.String, forceTextFormat: true }
    ]
};

export const DEVICE_AUDIT_TEMPLATE: SpreadsheetTemplate = {
  name: 'device-audit',
  columns: [
    { header: 'Serial Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'IMEI Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Item Type Type', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Previous Data', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Data After Change', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Date', type: ColumnDataType.Date },
    { header: 'Time (UTC)', type: ColumnDataType.Date },
    { header: 'Changed By', type: ColumnDataType.String, forceTextFormat: true }
  ]
};

export const AUDIT_LOGS_WITH_FULL_ACCESS_TEMPLATE: SpreadsheetTemplate = {
  name: 'audit-logs',
  columns: [
    { header: 'Partner', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Item Type', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Sub Item Type', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Action', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Previous Data', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Data After Change', type: ColumnDataType.Date },
    { header: 'Date', type: ColumnDataType.Date },
    { header: 'Time', type: ColumnDataType.Date },
    { header: 'Changed By', type: ColumnDataType.String, forceTextFormat: true }
  ]
};

export const AUDIT_LOGS_TEMPLATE: SpreadsheetTemplate = {
  name: 'audit-logs',
  columns: [
    { header: 'Item Type', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Sub Item Type', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Previous Data', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Data After Change', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Date', type: ColumnDataType.Date },
    { header: 'Time', type: ColumnDataType.Date },
    { header: 'Changed By', type: ColumnDataType.String, forceTextFormat: true }
  ]
};

export const BULK_UPLOAD_TEMPLATE: SpreadsheetTemplate = {
  name: 'bulk-device-upload-template',
  columns: [
    { header: 'SIM Serial Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Phone Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'SIM Provider', type: ColumnDataType.String },
    { header: 'Device Serial Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Device IMEI Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Device Type', type: ColumnDataType.String },
    { header: 'Channel Partner', type: ColumnDataType.String },
    { header: 'Issue Date', type: ColumnDataType.Date },
  ]
};

export const BULK_ALLOCATE_SIMS_TEMPLATE: SpreadsheetTemplate = {
  name: 'bulk_sim_allocation_template',
  columns: [
    { header: 'SIM Serial Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Phone Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'SIM Provider', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Device Serial Number', type: ColumnDataType.String, forceTextFormat: true },
    { header: 'Device IMEI Number', type: ColumnDataType.String, forceTextFormat: true }
  ]
};

export interface RequiredColumn {
  header: string;
  type: ColumnDataType;
  forceTextFormat?: boolean;
}

export interface SpreadsheetTemplate {
    name: string;
    columns: RequiredColumn[];
}
  
